/**
 * Sessão no FE: o access JWT fica só em cookie HttpOnly.
 * localStorage.authToken guarda apenas um marcador (não é o JWT).
 */
export const AUTH_SESSION_MARKER = 'httponly';

/** Mesma aba: storage event não dispara — listeners (ex.: chat) recarregam sessão. */
export const AUTH_SESSION_CHANGE_EVENT = 'painel-auth-session-change';

function dispatchAuthSessionChange(active) {
  try {
    window.dispatchEvent(
      new CustomEvent(AUTH_SESSION_CHANGE_EVENT, { detail: { active: Boolean(active) } })
    );
  } catch (_) {
    /* ignore */
  }
}

export function markAuthSession() {
  try {
    localStorage.setItem('authToken', AUTH_SESSION_MARKER);
  } catch (_) {
    /* ignore */
  }
  dispatchAuthSessionChange(true);
}

export function clearAuthSession() {
  try {
    localStorage.removeItem('authToken');
  } catch (_) {
    /* ignore */
  }
  dispatchAuthSessionChange(false);
}

/**
 * Carrega perfil completo via /api/auth/verify (fonte da verdade pós-login).
 * @param {string} apiBase
 * @returns {Promise<object|null>}
 */
export async function fetchSessionUser(apiBase) {
  const base = String(apiBase || '').replace(/\/$/, '');
  const response = await fetch(`${base}/api/auth/verify`, {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });
  const result = await response.json().catch(() => ({}));
  if (result && result.success && result.user) {
    return result.user;
  }
  return null;
}

/** ID do usuário MSSQL para auditoria (cookie HttpOnly — não decodificar authToken do localStorage). */
export function resolveSessionUserId(currentUser) {
  if (currentUser?.id != null && String(currentUser.id).trim() !== '') {
    return currentUser.id;
  }
  try {
    const raw = localStorage.getItem('userData');
    if (raw) {
      const ud = JSON.parse(raw);
      if (ud?.id != null && String(ud.id).trim() !== '') return ud.id;
    }
  } catch (_) {
    /* ignore */
  }
  const legacy = getLegacyAccessToken();
  if (legacy) {
    try {
      const payload = JSON.parse(atob(legacy.split('.')[1]));
      if (payload?.id != null) return payload.id;
    } catch (_) {
      /* ignore */
    }
  }
  return null;
}

/** True se há marcador de sessão (ou legado JWT antigo ainda presente). */
export function hasAuthSession() {
  try {
    const v = localStorage.getItem('authToken');
    return Boolean(v && String(v).trim());
  } catch (_) {
    return false;
  }
}

/**
 * Só devolve JWT se ainda existir legado no localStorage.
 * Com cookie HttpOnly o marcador não é JWT — retorna null.
 */
export function getLegacyAccessToken() {
  try {
    const v = String(localStorage.getItem('authToken') || '').trim();
    if (!v || v === AUTH_SESSION_MARKER) return null;
    const parts = v.split('.');
    if (parts.length === 3 && v.length > 20) return v;
    return null;
  } catch (_) {
    return null;
  }
}
